import {
  VcsIntegrationTestType,
  VcsIntegrationCheck,
  VcsIntegrationTestStatus,
} from "types/generated";

import { GITHUB_PERMISSIONS_DETAILS } from "../PermissionsDrawer/constants";
import { GithubPermissions } from "../types";

const generatePermissionsDetails = (permissions: GithubPermissions[] | undefined) => {
  return (permissions || [])
    .map((permission) => `${permission}: ${GITHUB_PERMISSIONS_DETAILS[permission]}`)
    .join(", ");
};

const generateSuccessStatusCheckTitle = (provider: string) => ({
  [VcsIntegrationTestType.Connection]: `Connection to ${provider} successful.`,
  [VcsIntegrationTestType.Permissions]: `Your ${provider} application is configured with correct permissions.`,
  [VcsIntegrationTestType.GithubAppEvents]: `We successfully checked that your ${provider} app is configured with all required events.`,
  [VcsIntegrationTestType.Webhook]: `Your ${provider} application webhook URL is configured correctly.`,
});

const generateFailedStatusCheckTitle = (provider: string, check: VcsIntegrationCheck) => ({
  [VcsIntegrationTestType.Connection]: `Unable to connect to ${provider}`,
  [VcsIntegrationTestType.Permissions]: `Your ${provider} application is missing required permissions: ${generatePermissionsDetails(check.metadata?.permissions as GithubPermissions[])}.`,
  [VcsIntegrationTestType.GithubAppEvents]: `Your ${provider} app is missing required events: ${(check.metadata?.githubAppEvents || []).join(", ")}.`,
  [VcsIntegrationTestType.Webhook]: `Your ${provider} application webhook configuration is incorrect.`,
});

export const generateStatusCheckTitle = (check: VcsIntegrationCheck, provider: string) => {
  const isStatusSuccess = check.status === VcsIntegrationTestStatus.Success;
  return isStatusSuccess
    ? generateSuccessStatusCheckTitle(provider)[check.type]
    : generateFailedStatusCheckTitle(provider, check)[check.type];
};
